(function() {
  "use strict";

  angular.module("sempraWebapp").constant("ukTranslations", {
    MESSAGE:"Повідомлення",
    ERROR_TITLE:"Помилка",
    ERROR_MESSAGE:"Виникла помилка при виконанні операції.",
    ERROR_LOGIN:"Під час входу в систему сталася помилка. Електронна адреса недійсна",
    ERROR_LOGIN_ROLE:"Роль для поточного бренду додатку не дійсна",
    OK:"ОК",
    CANCEL:"Відмінити",
    YES:"Так",
    NO:"Ні",
    FROM:"Від",
    TO:"До",
    DELETE:"Видалити",
    SIGN_OUT:"Вийти з аккаунта",
    NAME:"Ім'я",
    DATE:"Дата",
    PIECES:"частини",
    HOURS:"Години",
    DAYS:"Дні",
    MONTH:"Місяць",
    MONTHS:"Місяці",
    YEAR:"Рік",
    BOX:"Бокс",
    SEARCH:"Пошук",
    ALL_USERS:"Всі користувачі",
    ARE_YOU_SURE:"Ви впевнені?",
    BACK:"Назад",
    AMOUNT:"Сума",
    DESCRIPTION:"Опис",
    FORGOT_PASSWORD_ERROR_MSG:"Щось пішло не так. Будь ласка, перевірте свою адресу електронної пошти та повторіть спробу",
    REQUIRED_FIELD:"Поле обов'язкове",
    LOGOUT_TITLE:"Ви впевнені, що хочете вийти з системи?",
    LOGOUT_MSG:"Усі незбережені дані буде втрачено",
    ACTIVATION_ACCOUNT:"Ви успішно активували свій обліковий запис",
    UNKNOWN_ERRROR_NOTIFICATION:"Сталася невідома помилка",
    CONTINUE:"Продовжити",
    DATA_NOT_AVAILABLE:"Дані недоступні",
    SELECT:"Вибрати",
    SELECT_CURRENCY:"Виберіть валюту",
    UPLOAD:"Завантажити",
    PHONE:"Телефон",
    WEBSITE:"Веб-сайт",
    WORKING_HOURS:"Робочі години",
    INSERT:"Вставити",
    TEXT:"Текст",
    CREATED:"Створено",
    VALID_UNTIL:"Дійсний до",
    SAVE:"Зберегти",
    TOKENS:"Жетони",
    DELETE_COMPANY_HISTORY:"Видалити історію компанії?",
    DELETE_COMPANY_HISTORY_MESSAGE:"УВАГА: Після натискання цієї кнопки всі транзакції вашої автомийки будуть безповоротно видалені! Ці дані не можуть бути відновлені після видалення.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Ви впевнені, що хочете безповоротно видалити всі дані про транзакції?",
    HISTORY_SUCCESSFULY_DELETED:"Історія успішно видалена",
    HELP:"Допомога",
    VALUE:"Значення",
    ACTIVATING_ACCOUNT_ERROR:"Виникла проблема з активацією облікового запису R2W. Будь ласка, спробуйте ще раз, і якщо проблема не зникне, зверніться до нашої підтримки на support@ready2wash.com.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Ласкаво просимо до автомийки Kärcher",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Ласкаво просимо до R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Будь ласка, введіть новий пароль і підтвердьте його, щоб активувати обліковий запис R2W. Після успішного завершення вам автоматично буде відкрито вхід",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Ви пізніше можете змінити свої налаштування користувача в додатку",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Автомийка Kärcher",
    RESET_PASSWORD_WELCOME_MSG:"Автомийка R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Будь ласка, введіть новий пароль і підтвердіть його, щоб скинути старий пароль. У разі успіху ви будете автоматично авторизовані в додатку",
    RESET_PASSWORD_WELCOME_MSG_3:"Ви можете змінити свої налаштування пізніше в додатку",
    ENTER_NEW_PASSWORD:"Введіть новий пароль",
    REPEAT_NEW_PASSWORD:"Повторіть новий пароль",
    PASSWORD_MIN_LENGTH:"Пароль має містити принаймні 8 символів",
    PASSWORD_MAX_LENGHT:"Пароль має бути не більше 32 символів",
    PASSWORD_PATTERN:"Пароль повинен містити принаймні одну велику літеру та одну літеру нижнього регістру",
    PASSWORD_MATCH:"Паролі не збігаються",
    ACTIVATE:"Активувати",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Ви успішно подали запит. Будь ласка, перевірте електронну пошту на підтвердження",
    VALIDATION_REQUIRED:"Обов'язкове поле",
    VALIDATION_EMAIL:"невірна адреса електронної пошти",
    VALIDATION_INTEGER_NUMBER:"Будь ласка, введіть ціле значення",
    VALIDATION_HOURS_VALUE:"Значення має бути від 0 до 23",
    VALIDATION_MINUTES_VALUE:"Значення має бути від 0 до 59",
    VALIDATION_NOT_A_DATE:"Значення не є датою",
    VALIDATION_FROM:"Від дати більшої, ніж до",
    VALIDATION_TO:"На сьогоднішній день менше, ніж з",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Цей запис вже існує в базі даних",
    PASSWORD_VALIDATION_PATTERN_NEW:"Там повинна бути принаймні одна цифра та одна велика літери. Пробіли не допускаються",
    VALIDATION_PERCENT_VALUE:"Значення має бути між 1-999",
    NUMBERS_ONLY_100:"Номер до 100",
    NUMBERS_ONLY_1000:"Номер до 1000",
    POSITIVE_NUMBERS_ONLY:"Тільки позитивне число",
    GRID_PAGER_PAGE:"Сторінка",
    GRID_PAGER_ROWS_PER_PAGE:"Рядки на сторінку",
    GRID_PAGER_PAGE_OF:"від",
    BREAD_CRUMBS_HOME:"Головна",
    BREAD_CRUMBS_DASHBOARD_TECH:"Технологія панелі управління",
    BREAD_CRUMBS_DETAILS:"Подробиці",
    BREAD_CRUMBS_SETTINGS:"Налаштування",
    BREAD_CRUMBS_WORKING_HOURS:"Графік роботи",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Загальна сума грошей за днями",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Середня грошова інформація за годину",
    BREAD_CRUMBS_NEW_USER_GROUP:"Створити групу користувачів",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Редагувати групу користувачів",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Створити шаблон кампанії",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Редагувати шаблон кампанії",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Створити кампанію",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Редагувати кампанію",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Періодичний результат",
    LOGIN:"Увійти",
    EMAIL:"Електронна пошта",
    PASSWORD:"Пароль",
    LANGUAGE:"Мова",
    FORGOT_PASSWORD:"Забули пароль?",
    SUBMIT:"Відправити",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Кількість очікуваних сигналів:",
    HEADER_VIEW_ALL_ALARMS:"Переглянути всі сповіщення ...",
    HEADER_MY_ACCOUNT:"Мій рахунок",
    HEADER_ACCOUNT_MANAGEMENT:"Управління рахунками",
    ACCOUNT_ALREADY_EXIST:"Адреса електронної пошти вже використовується",
    NEWSLETTER_CONFIRMATION:"Надіслати сповіщення електронною поштою про стан тривоги",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Ohlyad shchodennykh finansiv",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Технологія панелі управління",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Панель приладів",
    ASIDE_MENU_ALARMS:"Повідомлення",
    ASIDE_MENU_FACILITIES:"Об'єкти",
    ASIDE_MENU_REPORTS:"Звіти",
    ASIDE_MENU_REPORT:"Обраний звіт",
    ASIDE_MENU_LOYALTY:"Лояльність",
    ASIDE_MENU_USER_GROUPS:"Групи користувачів",
    ASIDE_MENU_PERIODIC_SUMMARY:"Періодичний результат",
    ASIDE_MENU_MANAGING_TOKENS:"Керування токенами",
    ASIDE_MENU_NEWS:"Новини",
    DAILY_FINANCES_TOTAL_MONEY:"Всього грошей",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Сума грошей на всіх об'єктах",
    DAILY_FINANCES_TOTAL_COINS:"Усього використано металевих жетонів",
    DAILY_FINANCES_DOWNLOAD_CSV:"Завантажити CSV",
    DAILY_FINANCES_ONLINE:"R2W (онлайн)",
    DAILY_FINANCES_OFFLINE:"Готівка",
    DAILY_FINANCES_CHANGER:"Готівка в чейнджері",
    DAILY_FINANCES_COINS:"Токени / Eurokey",
    REPORTS_FILTER:"Фільтрувати",
    REPORTS_TYPE_OF_REPORT:"Тип звіту",
    REPORTS_CHOOSE_FACILITY:"Виберіть об'єкт",
    REPORTS_PERIOD_1:"Період 1 -",
    REPORTS_PERIOD_2:"Період 2 -",
    MONEY_BY_DATE_REPORT:"Сукупний дохід за датою",
    R2W_BY_DATE_REPORT:"Загальна кількість витрачених жетонів R2W за датою",
    COINS_BY_DATE_REPORT:"Всього монет за датою",
    AVG_MONEY_BY_HOUR_REPORT:"Середній дохід за годину",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Середній дохід за днем ​​тижня",
    AVG_MONEY_BY_BOX_REPORT:"Витрати на пральну машину",
    COMPARE_PERIODS_REPORT:"Порівняльний звіт по об'єкту",
    TOTAL_USERS_BY_GROUP:"Всього користувачів програми R2W за день",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"користувачів",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"відвідування",
    VISITS_COUNT_REPORT:"Кількість користувачів додатка R2W за кожне відвідування",
    LOYALTY_PER_DAY_REPORT:"Кількість локальних жетонів, витрачених за день",
    LOYALTY_PER_PAYMENT_METHOD:"Враховуючи локальні жетони за кожним способом оплати",
    VISITS:"Відвідування",
    VISIT:"Візити",
    TOTAL_SPENT_MONEY:"Загальний дохід",
    MONEY:"Гроші",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Загальна кількість витрачених грошей за період",
    DOWNLOAD_CSV:"Завантажити CSV",
    TOTAL_SPENT_COINS:"Всього витрачено жетонів",
    TOTAL_USERS:"Всього користувачів",
    TOTAL_CREDIT_GIVEN:"Всього витрачено локальних віртуальних жетонів",
    EUROKEY_BY_DATE_REPORT:"Загальна сума платежів Eurokey за датою",
    TOTAL_SPENT_EUROKEY:"Усього витрачено",
    SELECT_TYPE_OF_REPORT:"Вам потрібно вибрати тип звіту :)",
    NUMBER_OF_VISITS_TITLE:"Кількість відвідувань",
    NUMBER_OF_USERS_TITLE:"Кількість користувачів",
    PIECES_TITLE:"Шматки",
    TOTAL_VISITS:"Всього відвідувань",
    TOKENS_TITLE:"жетон",
    SEARCH_USERS_NO_RESULTS:"Не знайдено жодного користувача за даним пошуковим терміном",
    SEARCH_USERS:"Пошук користувачів",
    SEARCH_TELEPHONES:"Пошук користувачів за мобільним номером",
    ADD_USER_TO_GROUP:"Додати користувача до групи",
    REMOVE_USER_FROM_GROUP:"Видалити користувача з групи",
    USER_GROUP_NAME_REQUIRED:"Ім'я групи користувачів обов'язкове",
    USER_GROUP_NAME:"Назва групи користувачів",
    USER_GROUPS_OVERVIEW:"Огляд груп користувачів",
    USER_COUNT:"Кількість користувачів",
    NEW_USER_GROUP:"Створити нову групу користувачів",
    DELETE_USER_GROUP:"Видалити групу користувачів",
    UPDATE_USER_GROUP:"Редагувати групу користувачів",
    DELETE_USER_GROUP_ERROR:"Під час видалення вибраної групи користувачів виникла помилка. Будь ласка, повторіть спробу або зв'яжіться зі службою підтримки",
    CONFIRM_DELETE_USER_GROUP:"Ви впевнені, що хочете видалити вибрану групу користувачів?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Дії лояльності, на які покладена видалена група, більше не застосовуватимуться.",
    GROUP_NAME_MAX_LENGTH:"Назва групи має містити не більше 255 символів",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Користувач вже знаходиться в цій групі",
    MISSING_USER:"Відсутній користувач",
    USER_NOT_ON_LIST:"Користувач не знаходиться в списку активних користувачів. Перевірте правильність електронної адреси та повторіть спробу.",
    UPLOAD_USER_GROUP:"Завантажте список груп користувачів із файлу * .csv",
    UKNOWN_USERS:"Список невідомих користувачів",
    CAMPAIGN_TEMPLATE_RULE:"Правило шаблону",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Під час спроби видалити шаблон кампанії сталася помилка. Будь ласка, повторіть спробу або зв'яжіться зі службою підтримки",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Ви впевнені, що хочете видалити вибраний шаблон кампанії",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Ви впевнені, що хочете видалити вибраний шаблон кампанії",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Огляд шаблонів кампанії",
    DELETE_CAMPAIGN_TEMPLATE:"Видалити шаблон кампанії",
    UPDATE_CAMPAIGN_TEMPLATE:"Редагувати шаблон кампанії",
    CREATE_CAMPAIGN_TEMPLATE:"Створіть новий шаблон кампанії",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ім'я шаблону кампанії обов'язкове",
    CAMPAIGN_TEMPLATE_NAME:"Назва шаблону кампанії",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Обов'язкове поле",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Дай",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"кредити",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Виберіть спочатку тип. Коробки для прання або Малі машини.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Видалити правило шаблону",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Від",
    CAMPAIGN_TEMPLATE_RULE_TO:"до",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"годин",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"хвилин",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Нове правило за кількістю візитів",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Нове правило за кількістю витрачених грошей",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Нове правило за днями тижня",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Додайте нове правило шаблону",
    CAMPAIGN_TEMPLATE_RULE_1:"Кожен",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Кожен",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"кредити, витрачені менш ніж на",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"відвідування менш ніж",
    CAMPAIGN_TEMPLATE_RULE_3:"дні",
    CAMPAIGN_TEMPLATE_RULE_4:"кредити",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Список правил порожній.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Дата не може бути в минулому",
    DELETE_CAMPAIGN_ERROR:"Під час спроби видалити кампанію сталася помилка. Будь ласка, повторіть спробу або зв'яжіться зі службою підтримки",
    CONFIRM_DELETE_CAMPAIGN:"Ви впевнені, що хочете видалити вибрану кампанію?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W не несе відповідальності за користувацький досвід, викликаний цією дією.",
    CAMPAIGNS_OVERVIEW:"Огляд кампаній",
    DELETE_CAMPAIGN:"Видалити кампанію",
    UPDATE_CAMPAIGN:"Редагувати кампанію",
    CREATE_CAMPAIGN:"Створити нову кампанію",
    CAMPAIGN_ACTIVE:"Активний",
    CAMPAIGN_TEMPLATE:"Шаблон",
    CAMPAIGN_GROUPS:"Групи",
    CAMPAIGN_ALL_USERS:"Всі користувачі",
    CAMPAIGN_NAME:"Назва кампанії",
    CAMPAIGN_NAME_REQUIRED:"Обов'язково",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Кількість користувачів переддень",
    MESSAGE_TO_USERS:"Повідомлення для відфільтрованих користувачів",
    SEND_MESSAGE:"Відправити повідомлення",
    THRESHOLD:"Переддень",
    TYPE:"Тип",
    TOTAL_MONEY_SPENT:"Загальні витрачені гроші в кампанії",
    NUMBER_OF_VISITS:"Кількість відвідувань у кампанії",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Повідомлення має містити щонайменше 10 символів",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Повідомлення має бути не більше 350 символів",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Текст повідомлення обов'язковий",
    TECHNOLOGY:"Технологія",
    TAP_WATER:"Вода вхiдна",
    REVERSE_OSMOSIS:"Зворотній осмос",
    SOFTENED_WATER:"Пом'якшена вода",
    DOSER:"Дозатор",
    STATUS:"Стан справ",
    LAST_SYNCHRONIZATION:"Остання синхронізація",
    NO_OF_CURRENT_ALARMS:"Кількість поточних сигналів тривоги",
    NO_OF_CURRENT_WARNINGS:"Кількість поточних попереджень",
    WEATHER:"Погода",
    BOXES_WORK_HOURS_COUNTERS:"Годинники робочого часу",
    BOX_TOTAL_HOURS:"Загальний час роботи",
    BOX_SERVICE_HOURS:"Загальний час роботи (сервіс)",
    BOX_COUNTER_HOURS:"годин",
    ALARMS_AND_WARNINGS:"Сигнали та попередження",
    FILTER_AND_BOILER:"Фільтр і котел",
    FILTER_TOTAL_DAYS:"Фільтр робочі дні",
    BOILER_TOTAL_DAYS:"Робочі дні котла",
    DAYS_UNIT:"дні",
    SOFTENER:"Пом'якшувач",
    MANUAL_COLD_DRAIN:"Ручний холодний стік",
    EL_COLD:"Ел. холодний",
    DRAIN:"стік",
    TAP:"торкніться",
    WASTE:"Відходи",
    OSMOSIS:"осмос",
    DEMI_WATER:"Демініралізована вода",
    EL_RINSE:"Ел м. полоскання",
    BOILER:"Бойлер/Котел",
    EL_WAX:"Ел м. віск",
    FLOOR_HEATING:"Підігрів підлоги",
    DOSER_TANK:"Дозатор бак",
    EL_WASH:"Ел м. миття",
    DETERGENT:"Мікро-порошок",
    VIBRATOR:"Вібратор",
    UPDATE_FACILITY_SETTINGS:"Оновити налаштування",
    GENERAL_SETTINGS:"Загальні налаштування",
    LIGHTS:"Світло",
    GROUPS:"Групи",
    ANTI_FREEZE:"Антизамороження",
    AUTO:"Автоматично",
    MANUAL:"Вручну",
    ON:"Включити",
    OFF:"Вимкнути",
    TEMPERATURE:"Температура",
    UPDATE_DEVICE:"Оновлення налаштувань об'єкта",
    BOX_CLEAN_HOURS:"Бокс чистий лічильник (години)",
    GROUP_COUNTERS:"Групові лічильники",
    RESET:"Скинути",
    CASH_COUNT:"Кількість монет",
    COINS_COUNT:"Кількість жетонів",
    EUROKEY_COUNT:"Кількість Еurokey",
    DOSER_WORK:"Робочий час дозатора (сек.)",
    DOSER_PAUSE:"Час паузи дозатора (сек.)",
    DELAY_BFV:"Затримка BFV (мс)",
    DELAY_6M1:"Затримка 6M1 (мс)",
    DELAY_LPS:"Затримка LPS (мс)",
    RESET_CASH_COUNT_ALL:"Скинути всі лічильники монет",
    RESET_COINS_COUNT_ALL:"Скинути всі лічильники жетонів",
    RESET_EUROKEY_COUNT_ALL:"Скинути всі лічильники Еurokey",
    FACILITY_DETAILS:"Деталі об'єкта",
    FACILITY_NAME:"Назва об'єкта",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Ви успішно завантажили зображення",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Ви успішно оновили дані",
    CONNECTED:"пов'язаний",
    DISCONNECTED:"Відключено",
    OFFLINE:"відключений",
    MESSAGES_FILTER:"Фільтрувати повідомлення",
    FACILITY:"Об'єкт",
    APPLY:"Застосувати",
    TIME:"Час",
    LOCATION:"Місцезнаходження",
    ACKNOWLEDGED:"Визнано",
    FILTERED_MESSAGES:"Відфільтровані повідомлення",
    ACK:"Визнано",
    NOT_ACK:"Не визнано",
    ALL:"Всі",
    ALL_FACILITIES:"Всі об'єкти",
    ENTER_DATE_PLACEHOLDER:"Введіть дату",
    OP_NESTANAK_NAPONA:"Відсутня напруга на фазовому індикаторі 3А5",
    OP_OTB_PUMPA_GRESKA_MZS:"Автоматичний вимикач високого тиску скинуто",
    OP_UPR_NAPON_24VAC_GRE:"Відсутній 24 VAC - автоматичний вимикач 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Бак для прісної води порожній",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Автоматичний вимикач мережевого насосу скинуто",
    OP_MIN_NIVO_OMEKS_VODE:"Бак для пом'якшенної води порожній",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Насос циркуляції пом'якшенної води скинуто",
    OP_MIN_NIVO_DEMIN_VODE:"Бак осмосованної води порожній",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Насос циркуляції осмасованої води скинуто",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Автоматичний вимикач насосу виробництва осмосу скинуто",
    OP_BOJLER_GRESKA_MZS:"Помилка водонагрівача",
    OP_CRPKA_PRASKA_GRE_MZS:"Автоматичний вимикач гарячого водопостачання скинуто",
    OP_DOZATOR_PRASKA_GRE_MZS:"Автоматичний вимикач порошкового дозатора скинуто",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Вимикач порошкового дозування вібратора скинуто",
    OP_MIN_PRASAK_TON_ALARM:"Бак для змішування мікропорошку порожній",
    OP_USIS_KOV_TURBINA_GRESKA:"Автоматичний вимикач вакуумної турбіна всмоктування моонет/жетонів скинуто",
    OP_FILTER_VODE_ZACEPLJEN:"Фільтр води заблоковано",
    OP_VISKTL_RESET_SATI_RADA:"Сервіс насосу високого тиску",
    OPW_VISKTL_RESET_SATI_RADA:"Сервіс насосу високого тиску",
    OP_FILTER_DANI_RADA:"Помилка фільтра води",
    OP_BOJLER_DANI_RADA:"Помилка водонагрівача",
    OPW_ALARM_VISOKOTL_PUMPA:"Сигналізація насосу високого тиску",
    OPW_ALARM_FILTER_SERVIS:"Сигнал необхідного сервісу фільтра",
    OPW_ALARM_BOJLER_SERVIS:"Сигнал необхідного сервісу бойлера",
    HAS_MEMBERS:"Вибрана група має членів і їх неможливо видалити. Учасників потрібно спочатку видалити.",
    PERIODIC_SUMMARY_FOR:"ПЕРІОДИЧНИЙ ЗВІТ ПО",
    PERIODIC_SUMMARY_REPORTS:"Періодичні підсумкові звіти",
    DATE_RANGE:"Проміжок часу",
    FINANCIAL_REPORT:"Фінансовий звіт",
    GROSS_INCOME:"Валовий дохід",
    GROSS_INCOME_SUM:"Сума валового доходу",
    COMMISSION_FEE:"Комісійний збір",
    NET_INCOME:"Чистий прибуток (для виставлення рахунку)",
    COMMISSION_FEE_DETAILS:"Комісійний збір включаючи плату банку / PayPal або платіж постачальників SMS-послуг.",
    LOYALTY_CREDITS_REPORT:"Звіти по локальним жетонам",
    LOYALTY_GIVEN:"Враховуючи локальні жетони",
    LOYALTY_USED:"Використовані локальні жетони",
    LOYALTY_SOLD:"Локальні жетони завантажені",
    LOYALTY_TOTAL:"Всього",
    LOYALTY_CURRENT_MONTH:"Поточний місяць",
    SOMETHING_WENT_WRONG:"Упс....",
    MISSING_PAGE:"Вибачте, ми не змогли знайти цю сторінку",
    TRY_AGAIN:"Спробуйте ще раз",
    DEFAULT_ERROR_NAME:"Невідома помилка",
    DEFAULT_ERROR_DESCRIPTION:"Будь ласка спробуйте ще раз",
    MY_ACCOUNT_DETAILS:"Дані мого облікового запису",
    SAVE_CHANGES:"Зберегти зміни",
    USERNAME:"Ім'я користувача",
    FIRST_NAME:"Ім'я",
    LAST_NAME:"Прізвище",
    USER_ROLE:"Роль користувача",
    OLD_PASSWORD:"Старий пароль",
    NEW_PASSWORD:"Новий пароль",
    OLD_PASSWORD_REQUIRED:"Потрібний старий пароль",
    NEW_PASSWORD_REQUIRED:"Новий пароль обов'язковий",
    NEW_PASSWORD_REPEAT:"Необхідно повторити новий пароль",
    NEW_PASSWORD_NOT_MATCH:"Старий і новий пароль не збігаються",
    PASSWORD_DIFFERENT_VALIDATION:"Новий пароль повинен відрізнятися від старого",
    PASSWORD_MIN_CHAR:"Ваш пароль має містити принаймні 8 символів",
    PASSWORD_MAX_CHAR:"Ваш пароль має містити не більше 32 символів",
    PASSWORD_PATTERN_VALIDATION:"Пароль повинен містити принаймні одне число",
    ACCOUNT_MANAGEMENT:"Управління рахунками",
    NOT_ACTIVE:"Не активний",
    ASSIGN_ROLE:"Призначити роль",
    UPDATE:"Оновити",
    ADD_NEW_ACCOUNT:"Додати новий акаунт",
    EMAIL_REQUIRED:"Електронна адреса обов'язкова",
    EMAIL_NOT_VALID:"Електронна адреса недійсна",
    ADD_NEW_USER_TEXT:"Електронний лист з активаційним посиланням буде надісланий на вказану адресу електронної пошти.",
    UPDATE_USER_NOTIFICATION:"Ви успішно оновили свою інформацію",
    CHANGED_PASSWORD_NOTIFICATION:"Ви успішно змінили свій пароль",
    UPDATE_USER_GROUP_NOTIFICATION:"Ви успішно оновили назву групи користувачів",
    CREATE_USER_GROUP_NOTIFICATION:"Ви успішно створили групу",
    DETELE_USER_GROUP_NOTIFICATION:"Ви успішно видалили групу",
    EMPTY_GROUP_LIST_MSG:"Немає створених груп. Почніть із створення",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Ви успішно видалили користувача з групи",
    ADD_USER_TO_GROUP_NOTIFICATION:"Ви успішно додали користувача до групи",
    ADD_USER_NOTIFICATION:"Ви успішно додали нового користувача",
    DELETE_USER_NOTIFICATION:"Ви успішно видалили користувача",
    RESEND_USER_VERIFICATION_EMAIL:"Ви успішно повторно надіслали електронний лист з підтвердженням",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Для створення групи користувачів",
    DELETE_USER:"Видалити користувача",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Ви впевнені, що хочете видалити користувача з групи користувачів?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Шановний користувач R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Норма лояльності за кількістю візитів",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Норма лояльності на витрачену суму",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Норма лояльності на кожний день тижня",
    REMOVE_CAMPAIGN_RULE_TITLE:"Видалення правила кампанії",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Ви впевнені, що хочете видалити правило кампанії?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Ви успішно створили нову кампанію",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Ви успішно активували кампанію",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Немає створених кампаній. Почніть із створення",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Ви успішно надіслали повідомлення",
    COMPANY_ACCOUNTS:"Облікові записи компанії",
    BUSSINESS_INVOICES_LIST:"Мої рахунки-фактури на рахунку B2B",
    LOCALE_TOKEN:"Місцевий токен",
    R2W:"Глобальний токен",
    START_MONTH:"Початок місяця",
    END_MONTH:"Кінець місяця",
    TOKEN_TYPE:"Тип токена",
    TOKEN_NUMBER:"Номер токена",
    NOTHING_TO_DISPLAY:"* Нічого не відображати",
    CREATE_INVOICE:"Створити рахунок-фактуру",
    INVOICE:"Рахунок-фактура",
    INVOICES:"Рахунки-фактури",
    EDIT_INVOICE:"Редагувати рахунок-фактуру",
    UPDATE_INVOICE_NOTIFICATION:"Ви успішно оновили рахунок-фактуру в очікуваний статус",
    CURRENT_CHARGES:"Збори за поточний період",
    PAYMENTS_ON_HOLD:"Рахунки в обробці",
    FOR_INVOICING:"Для рахунків-фактур",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Ви збираєтеся скасувати рахунок-фактуру",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Ви впевнені, що хочете скасувати цей рахунок-фактуру?",
    INVOICING_NOTIFICATION_HEADER:"Ви збираєтеся робити виставлення рахунків",
    INVOICING_NOTIFICATION_TEXT:"Ви впевнені, що хочете надіслати рахунок-фактуру?",
    SENT_INVOICE_NOTIFICATION:"Ви успішно надіслали рахунок-фактуру",
    CANCELED_INVOICE_NOTIFICATION:"Ви успішно скасували рахунок-фактуру",
    INVOICE_DESCRIPTION_TEXT:"Рахунок для",
    INVOICE_STATE:"Стан рахунку-фактури",
    INVOICE_NUMBER:"Номер накладної",
    INVOICE_TOTAL:"Всього",
    SELECT_YEAR:"Виберіть рік",
    DOWNLOAD:"Завантажити PDF",
    INVOICE_NUMBER_HEADER:"Ви надішлете рахунок-фактуру з номером",
    INVOICE_PAYMENT_CONFIRMATION:"Ви хочете підтвердити оплату ",
    INSERT_INVOICE_NUMBER:"Введіть номер рахунку-фактури",
    INVOICED_WARNING:"Електронний лист не був надісланий. Будь ласка, зачекайте ...",
    SEND_INVOICE:"Відправити",
    INVOICE_ALL:"Все",
    INVOICE_FROM_R2W:"З R2W",
    INVOICE_TO_R2W:"До R2W",
    PAYMENT_REQUEST:"Запит на оплату",
    PAYMENT_REQUEST_STATE:"Стан запиту платежу",
    PAYMENT_REQUEST_NUMBER:"Номер заявки на оплату",
    FOR_PAYMENT_REQUEST:"Запит на оплату",
    PAYMENT_REQUEST_ON_HOLD:"Запит на оплату в процесі обробки",
    DOWNLOAD_INVOICE:"Завантажити рахунок-фактуру",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Натисніть для завантаження параметрів",
    B2B_SPEC:"B2B Специфікація",
    B2C_SPEC:"B2C Специфікація",
    DOWNLOAD_PAYMENT_REQUEST:"Завантажити платіжний запит",
    LOYALTY_PREVIEW:"Перевірка лояльності",
    ACTIVATED:"Активовано",
    RUNNING:"Хід",
    NOT_ACTIVATED:"Не активовано",
    FINISHED:"Готово",
    DEPRECATED:"Не призначено",
    UPCOMING:"Майбутні",
    NONE:"Ні",
    STARTED:"Початок",
    ENDS:"Закінчується",
    DEDICATED:"Присвячений",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Ви маєте активувати",
    CAMPAIGN:"кампанія",
    SEND_MESSAGE_NOTIFICATION:"Ви будете надсилати повідомлення вибраним групам користувачів",
    DIVISIBLE_TO_NUMBER:"Номер повинен бути ділиться на ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Тип пристрою",
    LISTENER:"Малі машини",
    BRIDGE:"Коробки для прання",
    WASH_BOXES:"Коробки для прання",
    VACUUMS:"Пилососи",
    SAVE_NEWS:"Зберегти новини",
    CREATE_NEW_NEWS:"Створити нові новини",
    HISTORY_OF_ALL_NEWS:"Історія всіх новин",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Введіть назву об'єкта",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Додати ще один об'єкт",
    NEWS_TEXT:"Текст новин",
    NEWS_TITLE:"Назва новин",
    DELETE_NEWS_CONFIRMATION:"Ви збираєтесь видаляти новини",
    NEWS_DELETE_NOTIFICATION:"Ви успішно видаляєте новини",
    NEWS_SAVE_NOTIFICATION:"Ви успішно зберегли новини",
    NEWS_CREATION_DATE:"Дата створення",
    NO_TITLE:"Немає заголовка",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Текст новин повинен містити не більше 255 символів",
    NEWS_TEXT_REQUIRED_VALIDATION:"Текст новин обов'язковий",
    NEWS_TITLE_REQUIRED_VALIDATION:"Заголовок новини обов'язковий",
    DEACTIVATE:"Деактивувати",
    ASIDE_MENU_LOCAL_TOKENS:"Локальні жетони",
    CREATE_NEW_LOCAL_TOKENS:"Випуск нових локальних жетонів",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Введіть адресу електронної пошти клієнта та кількість локальних жетонів, які ви хочете видати клієнту",
    CREATE_TOKENS:"Випуск жетонів",
    MINIMUM_ONE_TOKEN:"Значення має бути числом більше 0",
    CUSTOMER_EMAIL:"Електронна пошта клієнта",
    AMOUNT_OF_TOKENS:"Кількість жетонів",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Успішний випуск локальних жетонів на",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Виникла помилка при видачі локальних жетонів. Будь ласка, перевірте адресу електронної пошти клієнта та повторіть спробу.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Огляд випущених локальних жетонів",
    ISSUED_AT:"Виданий в",
    ISSUED_BY:"Випущено в",
    CODE:"Активувати код",
    REDEEMED_BY:"Викуплено",
    REDEEMED_AT:"Викуплено в",
    ASIDE_MENU_VOUCHERS:"Ваучери",
    PRINT:"Друк",
    VOUCHERS_OVERVIEW:"Огляд ваучерів",
    CREATE_NEW_VOUCHERS:"Створити нові ваучери",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Створіть нову викупну ваучерну партію, введіть кількість жетонів на ваучер",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Кількість жетонів на ваучер",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Ви можете призначити від 1 до 100 жетонів на ваучер",
    NUMBER_OF_NEW_VOUCHERS:"Кількість ваучерів, які потрібно створити",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Ви можете створювати від 1 до {{size}} ваучерів в одному пакеті",
    NEW_VOUCHERS_PREFIX:"Новий ваучер серійний код префікса",
    VALIDATION_VOUCHER_PREFIX:"Префікс коду повинен складати точно 4 символи (великими літерами та / або цифрами)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Виникла проблема з створенням нових ваучерів. Будь ласка, спробуйте ще раз або зверніться до нашої підтримки.",
    CREATE_VOUCHERS:"Створити ваучери",
    CREATING_VOUCHERS_SUCCESS:"Успішно створено нові ваучери",
    PRINT_NEW_VOUCHERS:"Друк ваучерів",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Введіть префікс коду ваучера, щоб надрукувати всю серію ваучерів. Альтернативно",
    PRINT_VOUCHERS_PREFIX:"Приставка ваучера (серії)",
    NO_VOUCHERS_FOR_PRINT:"Для друку не знайдено жодних ваучерів, що відповідають запропонованому префіксу коду",
    PRINT_VOUCHERS:"Друк ваучера (ів)",
    VALIDATION_VOUCHER_CODE_FILTER:"Пошуковий термін ваучер повинен складатися з великих літер та цифр",
    FILTER_VOUCHERS_BY_CODE:"Пошук ваучерів за викупним кодом",
    FILTER_VOUCHERS:"Пошукові ваучери",
    WASH_BOX:"Бокс мийки",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Усього використано цифрових токенів",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Загально придбані локальні жетони за день",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Загально витрачені локальні жетони за день",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Усього наданих локальних жетонів на день",
    LOCAL_TOKEN:"Локальний жетон",
    GIVEN_TOKEN:"Видані локальні жетони",
    SOLD_TOKEN:"Продано локальні жетони",
    SMALL_MACHINES:"Малі машини",
    R2W_Listener:"Слухач",
    HHANLE_DEVICE:"HHanle - Бокс мийки",
    CODE_PREFIX_EXIST:"Префікс коду вже існує",
    CODE_PREFIX_EXIST_TEXT:"Ви не можете створити новий ваучер з цим префіксом коду. Будь ласка, встановіть інший.",
    MIN_FOUR_VALIDATION:"Рівно 4 символи",
    ALL_INFORMATION_1:"Вся інформація про",
    ALL_INFORMATION_2:"буде втрачено",
    ASIDE_MENU_TRANSACTIONS:"Операції",
    EXPENSES:"Витрати",
    TOPUPS:"Придбані токени",
    EXPENSES_LIST:"Перелік витрат",
    USER_EMAIL:"Електронна пошта користувача",
    COMPANY_NAME:"Назва компанії",
    TOPUPS_LIST:"Список придбаних токенів",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Серійний номер",
    SETUP_UNIT_MATERIAL_NO:"Матеріальний номер",
    SETUP_UNIT_WEBAPI_VERSION:"Версія WebApi",
    TOTAL_TURNOVER:"Оборот автомийки",
    AVAILABILITY_ALL:"Доступність",
    AVAILIBILITY:"Доступність мийних боксів:",
    AVAILABILITY_VACUUMS:"Доступність пилососів:",
    WASH_BOX_INFO:"Інформація про мийні бокси",
    VACUUM_CLEANER_INFO:"Інформація про пилососи",
    BREAD_CRUMBS_SERVICE:"Послуга",
    HOLIDAYS:"Свята",
    HOLIDAY:"Свято",
    LIGHTS_ON:"Світло ввімкнено",
    LIGHTS_OFF:"Світло вимкнено",
    WASH_BOXES_ON:"Мийний бокс увімкнено",
    WASH_BOXES_OFF:"Мийний бокс вимкнено",
    VACUUMS_ON:"Пилососи увімкнено",
    VACUUMS_OFF:"Пилососи вимкнені",
    TURNOVER:"Оборот",
    TURNOVER_MANUAL_WASH_UNIT:"Інструкція з обороту",
    STATUS_BAY_RUN_TIME:"Загальний час роботи мийного боксу",
    STATUS_BAY_PROGRAM_NAME:"Назва програми",
    STATUS_BAY_CREDIT:"Кредит мийного боксу",
    CLOUD_KREDIT:"Кредит у хмарі",
    STATUS_VACUUM_RUN_TIME:"Загальний час роботи пилососа",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Послуги закладу, програма мийного боксу та інформація про поточні несправності",
    UNAVAILABLE:"Пристрій недоступний",
    SHOW_HIDE_TABLE:"Показати/сховати таблицю робочих годин",
    PROGRAM_NAME:"Назва програми",
    PROGRAM_OPTION:"Опція програми",
    DEVICE:"Пристрій",
    QUANTITY:"Кількість",
    PROGRAM_COUNTER:"Лічильник програми",
    NO_NAME:"Посилання не має назви",
    COUNTER_SERVICE_DATA:"Дані про послугу",
    NEED_SERVICE:"Потрібне обслуговування",
    PROGRAM_DATA:"Дані про програму мийного боксу",
    CURRENT_FAULT_DATA:"Поточні дані про несправності",
    REFERENCE_DUE:"Зараз",
    REFERENCE_SECONDS:"Секунди",
    REFERENCE_NAME:"Назва частини",
    WASHBOX_NAME:"Назва мийки",
    FAULT_NAME:"Назва несправності",
    FAULT_NUMBER:"Номер несправності",
    CURRENT_FAULT_COUNT:"Активні несправності",
    DEVICE_NOT_INSTALLED:"Пристрій не встановлено",
    STATUS_READY:"Стан готовості",
    STATUS_ERROR:"Стан помилки",
    CONNECTION_ERROR:"Офлайн",
    UNKNOWN_RESET:"Помилка програмного забезпечення",
    SOFTWARE_RESET:"Помилка програмного забезпечення",
    EXTERNAL_PIN_RESET:"Помилка програмного забезпечення",
    RESTART_OR_BROWNOUT_OCCURRED:"Помилка програмного забезпечення",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Помилка апаратного забезпечення",
    COULD_NOT_SIMULATE_COIN:"Помилка апаратного забезпечення",
    ERROR_SETTING_INHIBIT_MODE:"Помилка апаратного забезпечення",
    OFFLINE_DEVICE:"Автомийка офлайн",
    TARIFFS:"Тарифи",
    DAY:"День",
    NIGHT:"Ніч",
    VOUCHER_CODE:"Код ваучера",
    DISMISS_ALARM:"Скинути сигнал тривоги?",
    ALARM_ACTIVE:"Активні сигнали тривоги",
    NO_ALARM_ACTIVE:"Немає активних сигналів тривоги",
    ALARM_HISTORY:"Історія сповіщень",
    MANAGING_TOKENS:"Управління локальними токенами",
    EXPIRATION_DATE:"Термін придатності",
    EXTEND_TOKEN_DATE:"Подовжити термін дії маркера на",
    DELETE_TOKENS_FOR:" Видалити токени для",
    PUMP_TYPE:"Тип насосу",
    TURN_OFF_DEVICE:"Статус пристрою",
    OPERATION_DATA:"Дані про операцію",
    PUMP_DATA:"Дані насосу",
    PUMP_NAME:"Назва насосу",
    POINT_NAME:"Назва точки",
    CHANGER_INCOME:"Загальний дохід змінювача за датою",
    SELECTED_OPEN:"Відкрито в обраний робочий час",
    ALWAYS_OPEN:"Завжди відкрито (24/7)",
    CLOSED:"Закритий",
    CLOSED_24:"Закрито 24 години",
    OPENED_24:"Відкрито 24 години",
    MON:"Понеділок ",
    TUE:"Вівторок ",
    WED:"Середа ",
    THU:"Четвер ",
    FRI:"П’ятниця ",
    SAT:"Субота ",
    SUN:"Неділя ",
    PRICING:"Ціноутворення",
    PRICE:"Ціна",
    VALIDITY:"Дійсність",
    TOKEN_PACKAGES:"Пакети жетонів",
    SINGLE_WASH:"Одноразове миття",
    FACILITY_WORKING_HOURS:"Встановіть графік роботи для обраного об'єкта",
    WORKING_HOURS_ALWAYS_OPEN:"Завжди відкрито",
    WORKING_HOURS_ALWAYS_CLOSE:"Закривається оператором",
    WORKING_HOURS_CUSTOM:"Встановити графік роботи",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Організація",
    CREATE_ORGANIZATION:"Створити організацію",
    CREATE_ORGANIZATION_AS:"Створити організацію як дочірню для",
    DELETE_ORGANIZATION:"Видалити організацію",
    EDIT_ORGANIZATION:"Редагувати організацію",
    SUPPORTED_ORG_NAME:"Підтримувані організації",
    SUPPORTED_ORG_TYPE:"Підтримуваний тип",
    ORG_NAME:"Назва",
    ORG_TYPE:"Тип",
    SET_ORG_TITLE:"Встановити дочірню організацію",
    SET_SUPPORTED_ORG_TITLE:"Встановити підтримувану дочірню організацію",
    SAVE_ORGANIZATION:"Зберегти організацію",
    SELECT_ORGANIZATION_TYPE:"Вибрати тип організації",
    SELECT_ORGANIZATION_SELECTOR:"Вибрати",
    SELECT_SUPPORTED_ORGANIZATION:"Вибрати підтримувану організацію",
    ORGANIZATION_DELETED:"Організацію успішно видалено",
    ORGANIZATION_SAVED:"Організацію успішно збережено",
    ORGANIZATION_UPDATED:"Організацію успішно оновлено",
    ALERTS:"Сповіщення",
    DEVICE_STATUS:"Стан пристрою",
    SITE_DETAILS:"Інформація про сайт",
    ALARM_STATUS:"Статус оповіщення",
    FILTER:"Фільтрувати по ...",
    FILTER_BY_ALERT_CENTER:"Фільтрувати за кодом, назвою або описом",
    TOTAL_ALARM:"Всього",
    LOW_ALARM:"Подія",
    MEDIUM_ALARM:"Несправність",
    HIGH_ALARM:"Критична несправність",
    NO_FACILITIES_NEARBY:"Поблизу немає об'єктів",
    GRAY_MAP:"Карта в сірому кольорі",
    READY:"Готово",
    WARNING:"Несправність",
    ERROR:"Помилка",
    SITE_NAME:"Назва сайту",
    ACCOUNTS_INFO:"Інформація про обліковий запис",
    USER_ORGANIZATION:"Організація користувача",
    ADD_USER_ORGANIZATION:"Додати нового користувача організації",
    EDIT_USER_ORGANIZATION:"Редагування користувачів організації",
    SELECT_ROLE:"Виберіть роль",
    SELECT_ORGANIZATION:"Виберіть організацію",
    SELECT_USER:"Виберіть користувача",
    USER_FOR_ORGANIZATION_CREATED:"Новий користувач успішно створений",
    SELECT_REGION:"Виберіть регіон",
    SELECT_LANGUAGE:"Оберіть мову",
    LOADING_DATA:"Завантажуються дані, будь ласка, зачекайте ...",
    ADMINISTRATOR:"Адміністратор",
    TECHNICAL_SUPPORT:"Технічна підтримка",
    CONTROLLER:"Контролер",
    EDIT_ORGANIZATION_USER:"Редагувати користувачів організації",
    DELETE_ORGANIZATION_USER:"Видалення користувачів організації",
    USER_UPDATED:"Користувача успішно оновлено",
    USER_CREATED:"Користувача успішно створено",
    ADDRESS:"Адреса",
    SUBSCRIPTIONS:"Підписки",
    RESOLVED_STATUS:"Вирішено",
    NOT_RESOLVED_STATUS:"Не вирішено",
    ALERT_NAME:"Назва оповіщення",
    ALERT_DESCRIPTION:"Опис тривоги",
    ALERT_CODE:"Код тривоги",
    ALERT_TYPE:"Тип оповіщення",
    UNSUBSCRIBE:"Сповіщення про відписку",
    SUBSCRIBE:"Підписатися на оповіщення",
    ALARM_SUBSCRIBED:"Успішно підписано",
    UNSUBSCRIBED_CONFIRM:"Відмовитися від підписки?",
    ALARM_UNSUBSCRIBED:"Успішно скасовано підписку",
    ASIDE_MENU_CASHLESS_SALES:"Безготівкові продажі",
    FILTERED_CASHLESS_PAYMENTS:"Відфільтровані безготівкові платежі",
    REFUND_DIALOG_TITLE:"Відшкодувати транзакцію?",
    REFUND_DIALOG_SUBTITLE:"Сума може бути меншою або дорівнювати сумі транзакції",
    REFUND:"Відшкодування",
    INPUT_NOT_VALID:"Введені дані невірні",
    REFUND_SUCCESSFULLY:"Відшкодування за обраним платежем успішно виконано",
    USER:"Користувач",
    TRANSACTION_ID:"Посилання на PSP",
    DEVICE_ID:"ID пристрою",
    NET_AMOUNT:"Сума нетто",
    REPORT_NAME:"Назва звіту",
    TIME_FRAME:"Період часу",
    SUB_POINT:"Виберіть підпункт",
    SUB_POINT_LIST_NOT_EXIST:"Список підпунктів не існує для вибраної мийки",
    FACILITY_TYPE:"Тип мийки",
    MACHINE_NAME:"Назва машини",
    WASH_FACILITY_DETAILS:"Інформація про мийку",
    WASH_BAY_DETAILS:"Інформація про мийну камеру",
    DEVICES_INFO:"Список пристроїв",
    OPERATION_TIME_INFO:"Час роботи",
    OPERATION_TIME_VACUUM_INFO:"Час роботи пилососів",
    OPERATION_TIME_ILLUMINATION_INFO:"Час роботи освітлення",
    AVAILABLE_TITLE:"Доступно",
    UNAVAILABLE_TITLE:"Недоступно",
    CURRENT_PROGRAM:"Поточна програма",
    CREDITS:"Кредити",
    DEVICE_NAME:"Назва пристрою",
    ACTIVE_ALARMS:"Активні оповіщення",
    ALL_DAY:"Цілий день",
    OPERATING_TIME_WASH_FACILITY:"Система самообслуговування для миття",
    OPERATING_TIME_VACUUMS:"Пилососи",
    OPERATING_TIME_ILLUMINATION:"Освітлення",
    OPERATION_COUNTERS:"Лічильники операцій",
    EDIT:"Редагувати",
    WASHING_PROGRAMS:"Програми миття",
    INFO:"Подія",
    STATISTIC:"Статистика",
    ROLLOVER_DOSING:"Дозування",
    ROLLOVER_SPEED:"Швидкості",
    ROLLOVER_RESETS:"Ролловер - Дистанційне перезавантаження",
    ROLLOVER_RESETS_INFO:"Віддалене скидання має відбуватися відповідно до місцевих правил. Важливо: Перед скиданням переконайтеся, що ролловер порожній.",
    RESET_ROLLOVER:" Reset rollover",
    OPEN_DOOR_ROLLOVER:" Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
    ROLLOVER_OPEN_DOOR:" Open the door",
    APPLY_DOSING_CHANGES:"Внести зміни дозування",
    APPLY_SPEED_CHANGES:"Застосувати зміни швидкості",
    ACTUATION_SUCCESS:"Запит надіслано",
    REMAINING_TIME:"Час, що залишився",
    OPEN_24H:"Відкрити 24 години",
    CLOSE_24H:"Закрити 24 години",
    VALIDATION_OPERATION_TIME:"Неправильний формат. Використовуйте hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:"Оновити програму прання",
    UPDATE_ACTUATORS:"Update actuators",
    OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
    OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
    RESET_ROLOVER_TITLE:" Want to reset rollover?",
    RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
    G0:"{{brand === 'r2w' ? 'Пост 0' : 'Пост 1'}}",
    G1:"{{brand === 'r2w' ? 'Пост 1' : 'Пост 2'}}",
    G2:"{{brand === 'r2w' ? 'Пост 2' : 'Пост 3'}}",
    G3:"{{brand === 'r2w' ? 'Пост 3' : 'Пост 4'}}",
    G4:"{{brand === 'r2w' ? 'Пост 4' : 'Пост 5'}}",
    G5:"{{brand === 'r2w' ? 'Пост 5' : 'Пост 6'}}",
    G6:"{{brand === 'r2w' ? 'Пост 6' : 'Пост 7'}}",
    G7:"{{brand === 'r2w' ? 'Пост 7' : 'Пост 8'}}",
    G8:"{{brand === 'r2w' ? 'Пост 8' : 'Пост 9'}}",
    G9:"{{brand === 'r2w' ? 'Пост 9' : 'Пост 10'}}",
    G10:"{{brand === 'r2w' ? 'Пост 10' : 'Пост 11'}}",
    U0:"{{brand === 'r2w' ? 'Пилосос 0' : 'Пилосос 1'}}",
    U1:"{{brand === 'r2w' ? 'Пилосос 1' : 'Пилосос 2'}}",
    U2:"{{brand === 'r2w' ? 'Пилосос 2' : 'Пилосос 3'}}",
    U3:"{{brand === 'r2w' ? 'Пилосос 3' : 'Пилосос 4'}}",
    U4:"{{brand === 'r2w' ? 'Пилосос 4' : 'Пилосос 5'}}",
    U5:"{{brand === 'r2w' ? 'Пилосос 5' : 'Пилосос 6'}}",
    U6:"{{brand === 'r2w' ? 'Пилосос 6' : 'Пилосос 7'}}",
    U7:"{{brand === 'r2w' ? 'Пилосос 7' : 'Пилосос 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Звіт центру оповіщення, створений за вибраним об'єктом з інформаційної панелі",
    ALERT_CENTER_TITLE_BY_FACILITY:"Звіт центру оповіщення, створений за вибраним об'єктом з інформаційної панелі",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Звіт центру оповіщення",
    ERROR_MESSAGE_403:"У вас немає привілеїв для використання цього виклику api. Код помилки: 403",
    LAST_ACTIVE_PROGRAM:"Активна програма / Остання активна програма",
    PROGRAM_ID:"Номер програми",
    PROGRAM_PRICE:"Ціна програми",
    NORMAL_CHEMICAL_LEVEL:"ОК",
    LOW_CHEMICAL_LEVEL:"Потрібно поповнити запас",
    EMPTY_CHEMICAL_LEVEL:"Порожньо",
    CHEMICAL_LEVEL:"Індикація рівня миючих засобів (%)",
    ROLLOVER_STATUS:"Статус перекидання",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Критична несправність",
    NO_ALARM:"Немає критичної несправності",
    SOFTWARE_VERSION:"Версія програмного забезпечення",
    SOFTWARE_DATE:"Дата програмного забезпечення",
    SITE_ADDRESS:"Адреса сайту",
    SECONDS:"Секунди",
    SERVICE_PART_NAME:"Назва послуги:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Лічильник експлуатації та обслуговування",
    OPERATION_COUNTER:"Лічильник операцій",
    SERVICE_COUNTER:"Лічильник обслуговування",
    FAULT_CODE:"Код тривоги",
    PRESSURE_TITLE:"Тиск повітря",
    TIME_TITLE:"Поточний час",
    COUNTRY_TITLE:"Країна",
    CITY_TITLE:"Місто",
    REGION_TITLE:"Область",
    SELECT_POINTS_TO_SEARCH:"Вибрати пункти ...",
    LOGS_HISTORY:"Історія зміни параметрів",
    ACTUATOR_REFERENCE:"Посилання на привід",
    ACTUATOR_VALUE:"Значення приводу",
    POINT_ID:"Ідентифікатор точки",
    VALIDATION_NOT_VALID_RANGE:"Неправильний діапазон",
    ENABLE_ROLLOVER_RESET:"Встановивши цей прапорець, ви підтверджуєте, що ознайомилися з інструкціями з техніки безпеки та погоджуєтеся з ними.",
    CHANGE_OF_PARAMETERS:"Зміна параметрів",
    SELECT_OPTIONS:"Виберіть параметри",
    AUTOMATIC:"Автоматично",
    DESALTING:"Функція видалення солі",
    SEASON_WASH:"Сезонні програми мийки",
    SPRING_PROGRAM:"Весняні програми мийки",
    SUMMER_PROGRAM:"Літні програми мийки",
    AUTUMN_PROGRAM:"Осінні програми мийки",
    WINTER_PROGRAM:"Зимові програми мийки",
    DOOR_CONTROL:"Door control",
    SUMMER_DOOR_CONTROL:" Summer, operated with the gate control in summer mode",
    WINTER_DOOR_CONTROL:" Winter, operated with the gate control in winter mode",
    APPLY_PARAMETERS_CHANGES:"Застосувати зміни параметрів",
    WORKING_SCHEDULES:"Графіки роботи",
    HOLIDAY_SCHEDULES:"Графік святкових днів",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Святкові дні на об'єкті успішно створено",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Вихідні на об'єкті успішно оновлено",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Святкові дні на об'єкті успішно видалено",
    WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Робочі графіки на об'єкті успішно оновлено",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Робочі графіки успішно поширено",
    HOLIDAY_SUCCESSFULLY_DELETED:"Святковий день успішно видалено",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Засіб для сушіння з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_SHAMPOO:"Шампунь з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_FOAM:"Піна з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_WAX_1:"Віск з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_POLISH_1:"Поліроль з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Очищувач дисків з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_WAX_2:"Віск з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Блиск для шин з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Засіб для видалення комах з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_POLISH_2:"Поліроль з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_INTENSIVE:"Інтенсивний з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Пінний дощ з низьким рівнем заповнення",
    CHEM_LEVEL_DRYING_AGENT:"Засіб для сушіння з низьким рівнем заповнення",
    CHEM_LEVEL_SHAMPOO:"Шампунь з низьким рівнем наповнення",
    CHEM_LEVEL_FOAM:"Піна з низьким рівнем заповнення",
    CHEM_LEVEL_WAX_1:"Віск до рівня заповнення",
    CHEM_LEVEL_POLISH_1:"Поліроль для рівня заправки",
    CHEM_LEVEL_RIM_CLEANER:"Очищувач колісних дисків рівня заливки",
    CHEM_LEVEL_WAX_2:"Віск до рівня заправки",
    CHEM_LEVEL_TYRE_SHINE:"Блиск для шин на рівні заправки",
    CHEM_LEVEL_INSECT_REMOVER:"Засіб від комах на рівні заливної горловини",
    CHEM_LEVEL_POLISH_2:"Поліроль рівня заправки",
    CHEM_LEVEL_INTENSIVE:"Рівень заповнення інтенсивний",
    CHEM_LEVEL_FOAM_RAIN:"Рівень заправки пінний дощ",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Ремінь для підйому щітки для даху на сервісній стійці",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Ремінь для підйому сушарки на сервісній стійці",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Сервісний кабель моторної щітки для даху лічильника",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Сервісний лічильник обслуговування насоса свіжої води",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Сервісний лічильник насоса відпрацьованої води",
    DRYING_AGENT:"Сушильний агент",
    FOAM_DRYING_AGENT:"Піноутворювач для сушіння",
    SHAMPOO:"Шампунь",
    FOAM:"Піна",
    BRUSH_FOAM:"Піна для щіток",
    WAX_1:"Віск",
    FOAM_WAX_1:"Пінний віск",
    POLISH_1:"Поліроль",
    RIM_CLEANING:"Засіб для чищення дисків",
    WAX_2:"Віск",
    FOAM_WAX_2:"Пінний віск",
    TYRE_SHINE:"Блиск для шин",
    INSECT_REMOVER:"Засіб для видалення комах",
    POLISH_2:"Поліроль",
    INTENSIVE_BASIC:"Інтенсивна базова",
    INTENSIVE_SIDE:"Інтенсивний бічний",
    INTENSIVE_ROOF_SPRAY_BAR:"Інтенсивний розпилювач для даху",
    TAR_REMOVER:"Видалення гудрону",
    UNDER_CHASSIS_CONVERSATION:"Мийка шасі",
    STATIONARY_PRE_SPRAY_ARCH:"Стаціонарна дуга попереднього обприскування",
    FOAM_RAIN:"Пінний дощ",
    PRE_CLEANING:"Попереднє очищення",
    BRUSH:"Щітка",
    CARE:"Догляд",
    DRYING:"Сушка",
    DRYING_LOW_NOISE:"Сушка зі зниженим рівнем шуму",
    INTENSIVE_CLEANING:"Інтенсивне очищення",
    BRUSH_CLEANING:"Чистка щітки",
    EMPTY_RUN:"Порожній хід",
    DRYING_AID:"Засіб для сушіння",
    WAX:"Віск",
    FOAM_WASH:"Пінна мийка",
    POLISH:"Поліроль",
    FOAM_POLISH:"Поліроль з піни",
    WHEEL_CLEANING:"Очищення коліс",
    HIGH_PRESSURE_ROOF:"Високий тиск на даху",
    HIGH_PRESSURE_SIDE:"Боковий високий тиск",
    DRYER_FORWARD:"Сушарка вперед",
    DRYER_BACKWARD:"Сушарка назад",
    DELETE_ALL_HOLIDAYS:"Видалити всі свята для вибраного об'єкта",
    CREATE_NEW_HOLIDAY:"Створити новий",
    RESET_INPUTS:"Скинути всі входи святкових днів",
    TWENTY_FOUR_HOURS_OPEN:"Відкрито 24 години",
    EVERY_YEAR:"Щорічно",
    DELETE_HOLIDAY:"Видалити свято",
    ADD_NEW_HOLIDAY:"Додати нове свято",
    HOLIDAYS_LIST:"Список існуючих свят",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Видалити всі свята для вибраного сайту?",
    VALIDATION_HOLIDAY_DATE:"Неправильний формат. Використовуйте мм-дд",
    FOR_DATE:"За датою",
    WITH_ID:"З ідентифікатором",
    FROM_HOURS:"Від (год)",
    FROM_MINUTES:"Від (хв)",
    TO_HOURS:"До (год)",
    TO_MINUTES:"До (хв)",
    NOT_MATCH:"Не збігається",
    START:"Від",
    STOP:"До",
    DAILY_TIME:"Список на 24 години",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Індивідуальне налаштування часу",
    PROGRAM_NOT_STARTED:"Програма ще не запущена",
    JETWASH:"Система мийки самообслуговування",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"er: Кількість збоїв в електропостачанні",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Насос свіжої води",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Насос технічної води",
    OPERATION_COUNTER_HP_PUMP_1:"Насос високого тиску 1",
    OPERATION_COUNTER_HP_PUMP_2:"Насос високого тиску 2",
    RELEASE_NOTES:"Версії програми та примітки до випуску",
    BACKEND_RELEASE_NOTES:"Примітки до випуску платформи:",
    FRONTEND_RELEASE_NOTES:"Примітки до версії веб-додатку:",
    SELECTED_FACILITY_TIMEZONE:"Часовий пояс для вибраного об'єкта:",
    REFRESH_PAGE:"Оновити сторінку",
    REFRESH_MAPS:"Оновити мапи",
    PUMPS:"Насоси",
    RUN_TIME:"Час роботи",
    RUN_TIME1:"Час роботи 1",
    RUN_TIME2:"Час роботи 2",
    PROGRAM_RUNTIME_ACTUATOR:"Привід для часу роботи",
    PROGRAM_RUNTIME_ACTUATOR_1:"Привід для часу роботи 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Привід для часу роботи 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Мінімальне значення 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Максимальне значення 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Використовуйте формат ціни x.xx",
    ACTUATION_NOT_ALLOWED:"Активація заборонена для поточної ролі користувача",
    MAINTENANCE_DAYS:"Дні технічного обслуговування",
    MAINTENANCE_WASHES:"Технічне обслуговування мийки",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Загальний дохід POS",
    PROPAGATE:"Розповсюдити",
    ALL_DAY_HOURS_SELECTOR:"Селектор типу 24 години",
    GET_OPERATING_TIME_FROM_SITE:"Отримати час роботи поточного пристрою з розкладу роботи сайту",
    USER_NOT_VALID:"Користувач не дійсний. Спробуйте під іншим обліковим записом.",
    VERIFIED:"Підтверджено",
    RESEND_VERIFICATION_MAIL:"Повторно надіслати лист з підтвердженням",
    RETURN_TO_DASHBOARD:"Повернутися до інформаційної панелі",
    ERROR_PAGE_BAD_REQUEST:"400 Неправильний запит.",
    WASHES:"Кількість прань",
    TIME_TO_SERVICE:"Час до обслуговування",
    ACCOUNT_ALREADY_ACTIVATED:"Обліковий запис вже активовано",
    DEVICE_EVENTS:"Події пристрою",
    DEVICE_EVENTS_LOG_PULLED:"Витягнуто журнал подій для пристрою",
    EVENTS_PULL_DATE:"Час витягнення подій:",
    DEVICE_EVENTS_REFRESH:"Витягти нові дані подій",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Проблема з підключенням веб-сокетів. Спробуйте оновити сторінку.",
    INSTALLATION_DATE:"Дата встановлення машини",
    KARCHER_CUSTOM_PROGRAM_NAME_1:" Гарячий віск",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Миття під високим тиском",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Пінка для дисків",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Потужна пінка",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Зупинити",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Пінне миття HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Миття",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Преміум догляд",
    INFO_TITLE:"Інформація",
    FOAM_WAX1:"Пінний віск",
    POLISH1:"Поліроль",
    WAX1:"Віск",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Деталі сайту успішно оновлені",
    COMPANY:"Компанія",
    FACILITY_HAS_CHANGER:"Є змінювач?",
    DISABLE_OFFLINE_ALARM:"Вимкнути сигнали R2W",
    ASIDE_WORKING_SCHEDULES:"Деталі сайту додатку",
    TERMS_OF_SERVICE_R2W_TITLE:"Умови обслуговування Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Умови обслуговування Ready2Wash",
    DATA_PROCESSING_TITLE:"Дані оброблені",
    PRIVACY_POLICY_TITLE:"Політика конфіденційності",
    READY_TO_PAY_TERMS_OF_SERVICE:"Умови обслуговування Ready2Pay",
    TERMS_AND_SERVICES:"Умови та послуги",
    HOURLY: "Щогодини",
    DAILY: "Щодня",
    WEEKLY: "Щотижня",
    MONTHLY: "Щомісяця",
    YEARLY: "Щороку",
    DELETE_ITEM_SUCCESS:"Ви успішно видалили елемент",
    STATE: "Стан",
    AVAILABILITY_STATUS_1: "Пристрій відкрито",
    AVAILABILITY_STATUS_2: "Пристрій закрито (відпустка)",
    AVAILABILITY_STATUS_3: "Пристрій закрито (робочий час)",
    AVAILABILITY_STATUS_4: "Пристрій закрито (несправність)",
    AVAILABILITY_STATUS_5: "Пристрій закрито (інше)",
    AVAILABILITY_VACUUMS_STATUS_1: "Пилососи не встановлені",
    AVAILABILITY_VACUUMS_STATUS_2: "Пилососи відкриті",
    AVAILABILITY_VACUUMS_STATUS_3: "Пилососи закрито (відпустка)",
    AVAILABILITY_VACUUMS_STATUS_4: "Пилососи закрито (робочий час)",
    AVAILABILITY_VACUUMS_STATUS_5: "Пилососи закрито (несправність)",
    AVAILABILITY_VACUUMS_STATUS_6: "Пилососи закрито (інше)",
    ECOM_AMOUNT: "Загальний Ecom для всіх локацій",
    CAPTURED: "Зареєстровано",
    DELETE_COMPANY_HISTORY_INFO:"Ця дія видалить усі дані звітів вашої компанії. Цю дію неможливо скасувати.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Ви впевнені, що хочете назавжди видалити всі дані звітів?",
    VALUE_DATE: "Дата валютування",
    KARCHER_EVENT_NAME_1: "Основний теплообмінник регенеровано",
    KARCHER_EVENT_NAME_2: "Регенерацію основного теплообмінника завершено",
    KARCHER_EVENT_NAME_3: "Матеріал / серійний номер",
    KARCHER_EVENT_NAME_4: "Система продезінфікована",
    KARCHER_EVENT_NAME_5: "HP насос 1 продезінфіковано",
    KARCHER_EVENT_NAME_6: "HP насос 2 продезінфіковано",
    KARCHER_EVENT_NAME_7: "HP насос 3 продезінфіковано",
    KARCHER_EVENT_NAME_8: "HP насос 4 продезінфіковано",
    KARCHER_EVENT_NAME_9: "HP насос 5 продезінфіковано",
    KARCHER_EVENT_NAME_10: "Мийна станція 1 заблокована",
    KARCHER_EVENT_NAME_11: "Мийна станція 2 заблокована",
    KARCHER_EVENT_NAME_12: "Мийна станція 3 заблокована",
    KARCHER_EVENT_NAME_13: "Мийна станція 4 заблокована",
    KARCHER_EVENT_NAME_14: "Мийна станція 5 заблокована",
    KARCHER_EVENT_NAME_15: "Мийна станція 6 заблокована",
    KARCHER_EVENT_NAME_16: "Мийна станція 7 заблокована",
    KARCHER_EVENT_NAME_17: "Мийна станція 8 заблокована",
    KARCHER_EVENT_NAME_18: "Оновлення розпочато",
    KARCHER_EVENT_NAME_19: "Оновлення завершено",
    KARCHER_EVENT_NAME_20: "Початок реєстрації WS",
    KARCHER_EVENT_NAME_21: "Кінець реєстрації WS",
    KARCHER_EVENT_NAME_22: "Датчик WS 75%",
    KARCHER_EVENT_NAME_23: "Технічна помилка",
    KARCHER_EVENT_NAME_24: "Операційна помилка",
    KARCHER_EVENT_NAME_25: "Пристрій увімкнено",
    KARCHER_EVENT_NAME_26: "Пристрій вимкнено",
    KARCHER_EVENT_NAME_27: "Шафа 1 закрита",
    KARCHER_EVENT_NAME_28: "Шафа 2 закрита",
    KARCHER_EVENT_NAME_29: "Шафа 3 закрита",
    KARCHER_EVENT_NAME_30: "Шафа 4 закрита",
    KARCHER_EVENT_NAME_31: "Шафа 5 закрита",
    KARCHER_EVENT_NAME_32: "Шафа 6 закрита",
    KARCHER_EVENT_NAME_33: "Шафа 7 закрита",
    KARCHER_EVENT_NAME_34: "Шафа 8 закрита",
    KARCHER_EVENT_NAME_35: "Насосна станція HP 1",
    KARCHER_EVENT_NAME_36: "Насосна станція HP 2",
    KARCHER_EVENT_NAME_37: "Насосна станція HP 3",
    KARCHER_EVENT_NAME_38: "Насосна станція HP 4",
    KARCHER_EVENT_NAME_39: "Насосна станція HP 5",
    KARCHER_EVENT_NAME_40: "Насосна станція HP 6",
    KARCHER_EVENT_NAME_41: "Насосна станція HP 7",
    KARCHER_EVENT_NAME_42: "Насосна станція HP 8",
    KARCHER_EVENT_NAME_43: "Горілка",
    KARCHER_EVENT_NAME_44: "Вентилятор горілки",
    KARCHER_EVENT_NAME_45: "Насос для гарячої води",
    KARCHER_EVENT_NAME_46: "Насос для захисту від замерзання",
    KARCHER_EVENT_NAME_47: "Осмотичний насос",
    KARCHER_EVENT_NAME_48: "Підігрів підлоги",
    KARCHER_EVENT_NAME_49: "Підігрів шланга",
    KARCHER_EVENT_NAME_50: "Мікро/чистка колісних дисків",
    KARCHER_EVENT_NAME_51: "Насос для миття шасі",
    KARCHER_EVENT_NAME_52: "Насос для піноутворення Booster",
    KARCHER_EVENT_NAME_53: "Пилосос 1",
    KARCHER_EVENT_NAME_54: "Пилосос 2",
    KARCHER_EVENT_NAME_55: "Пилосос 3",
    KARCHER_EVENT_NAME_56: "Пилосос 4",
    KARCHER_EVENT_NAME_57: "Пилосос 5",
    KARCHER_EVENT_NAME_58: "Пилосос 6",
    KARCHER_EVENT_NAME_59: "Пилосос 7",
    KARCHER_EVENT_NAME_60: "Пилосос 8",
    KARCHER_EVENT_NAME_61: "Пилосос 9",
    KARCHER_EVENT_NAME_62: "Пилосос 10",
    KARCHER_EVENT_NAME_63: "Пилосос 11",
    KARCHER_EVENT_NAME_64: "Пилосос 12",
    KARCHER_EVENT_NAME_65: "Насос для очищення колісних дисків",
    KARCHER_EVENT_NAME_66: "Мікронасос",
    KARCHER_EVENT_NAME_67: "Інтенсивний насос",
    KARCHER_EVENT_NAME_68: "Турбіна пилососа 1",
    KARCHER_EVENT_NAME_69: "Фільтр пилососа 1",
    KARCHER_EVENT_NAME_70: "Турбіна пилососа 2",
    KARCHER_EVENT_NAME_71: "Фільтр пилососа 2",
    KARCHER_EVENT_NAME_72: "Турбіна пилососа 3",
    KARCHER_EVENT_NAME_73: "Фільтр пилососа 3",
    KARCHER_EVENT_NAME_74: "Турбіна пилососа 4",
    KARCHER_EVENT_NAME_75: "Фільтр пилососа 4",
    KARCHER_EVENT_NAME_76: "Турбіна пилососа 5",
    KARCHER_EVENT_NAME_77: "Фільтр пилососа 5",
    KARCHER_EVENT_NAME_78: "Турбіна пилососа 6",
    KARCHER_EVENT_NAME_79: "Фільтр пилососа 6",
    KARCHER_EVENT_NAME_80: "Турбіна пилососа 7",
    KARCHER_EVENT_NAME_81: "Фільтр пилососа 7",
    KARCHER_EVENT_NAME_82: "Турбіна пилососа 8",
    KARCHER_EVENT_NAME_83: "Фільтр пилососа 8",
    KARCHER_EVENT_NAME_84: "Турбіна пилососа 9",
    KARCHER_EVENT_NAME_85: "Фільтр пилососа 9",
    KARCHER_EVENT_NAME_86: "Турбіна пилососа 10",
    KARCHER_EVENT_NAME_87: "Фільтр пилососа 10",
    KARCHER_EVENT_NAME_88: "Турбіна пилососа 11",
    KARCHER_EVENT_NAME_89: "Фільтр пилососа 11",
    KARCHER_EVENT_NAME_90: "Турбіна пилососа 12",
    KARCHER_EVENT_NAME_91: "Фільтр пилососа 12",
    INSERT_TOKEN: "Введіть токен та запустіть сервіс",
    OPEN_SESSION: "Сесію успішно відкрито",
    IN_PROGRESS: "В процесі...",
    TOKEN_INSERTED: "Токен успішно введено",
    EXPIRED_SESSION: "Сесія завершилася",
    TWO_DIGIT_INTEGER_VALIDATION: "Використовуйте ціле число з максимум двома цифрами",
    KARCHER_OPERATION_COUNTER_1: "Мийна станція 1, високонапірний насос",
    KARCHER_OPERATION_COUNTER_2: "Мийна станція 1, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_3: "Мийна станція 1, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_4: "Мийна станція 1, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_5: "Мийна станція 1, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_6: "Мийна станція 2, високонапірний насос",
    KARCHER_OPERATION_COUNTER_7: "Мийна станція 2, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_8: "Мийна станція 2, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_9: "Мийна станція 2, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_10: "Мийна станція 2, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_11: "Мийна станція 3, високонапірний насос",
    KARCHER_OPERATION_COUNTER_12: "Мийна станція 3, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_13: "Мийна станція 3, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_14: "Мийна станція 3, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_15: "Мийна станція 3, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_16: "Мийна станція 4, високонапірний насос",
    KARCHER_OPERATION_COUNTER_17: "Мийна станція 4, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_18: "Мийна станція 4, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_19: "Мийна станція 4, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_20: "Мийна станція 4, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_21: "Мийна станція 5, високонапірний насос",
    KARCHER_OPERATION_COUNTER_22: "Мийна станція 5, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_23: "Мийна станція 5, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_24: "Мийна станція 5, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_25: "Мийна станція 5, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_26: "Мийна станція 6, високонапірний насос",
    KARCHER_OPERATION_COUNTER_27: "Мийна станція 6, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_28: "Мийна станція 6, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_29: "Мийна станція 6, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_30: "Мийна станція 6, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_31: "Мийна станція 7, високонапірний насос",
    KARCHER_OPERATION_COUNTER_32: "Мийна станція 7, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_33: "Мийна станція 7, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_34: "Мийна станція 7, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_35: "Мийна станція 7, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_36: "Мийна станція 8, високонапірний насос",
    KARCHER_OPERATION_COUNTER_37: "Мийна станція 8, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_38: "Мийна станція 8, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_39: "Мийна станція 8, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_40: "Мийна станція 8, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_41: "Осмосний насос",
    KARCHER_OPERATION_COUNTER_42: "Генератор гарячої води",
    KARCHER_OPERATION_COUNTER_43: "Насос захисту від замерзання",
    KARCHER_OPERATION_COUNTER_44: "Фільтри WSO",
    KARCHER_OPERATION_COUNTER_45: "Насос нагріву мийної станції",
    KARCHER_OPERATION_COUNTER_46: "Насос гарячої води",
    KARCHER_OPERATION_COUNTER_47: "Нагрівач для піни у шлангах",
    KARCHER_OPERATION_COUNTER_48: "Насос для миття коліс",
    KARCHER_OPERATION_COUNTER_49: "Мікроемульсійний насос",
    KARCHER_OPERATION_COUNTER_50: "Інтенсивний насос піни",
    KARCHER_OPERATION_COUNTER_51: "Пилосос 1 турбіна 1",
    KARCHER_OPERATION_COUNTER_52: "Пилосос 1 фільтр 1",
    KARCHER_OPERATION_COUNTER_53: "Пилосос 1 турбіна 2",
    KARCHER_OPERATION_COUNTER_54: "Пилосос 1 фільтр 2",
    KARCHER_OPERATION_COUNTER_55: "Пилосос 2 турбіна 1",
    KARCHER_OPERATION_COUNTER_56: "Пилосос 2 фільтр 1",
    KARCHER_OPERATION_COUNTER_57: "Пилосос 2 турбіна 2",
    KARCHER_OPERATION_COUNTER_58: "Пилосос 2 фільтр 2",
    KARCHER_OPERATION_COUNTER_59: "Пилосос 3 турбіна 1",
    KARCHER_OPERATION_COUNTER_60: "Пилосос 3 фільтр 1",
    KARCHER_OPERATION_COUNTER_61: "Пилосос 3 турбіна 2",
    KARCHER_OPERATION_COUNTER_62: "Пилосос 3 фільтр 2",
    KARCHER_OPERATION_COUNTER_63: "Пилосос 4 турбіна 1",
    KARCHER_OPERATION_COUNTER_64: "Пилосос 4 фільтр 1",
    KARCHER_OPERATION_COUNTER_65: "Пилосос 4 турбіна 2",
    KARCHER_OPERATION_COUNTER_66: "Пилосос 4 фільтр 2",
    KARCHER_OPERATION_COUNTER_67: "Пилосос 5 турбіна 1",
    KARCHER_OPERATION_COUNTER_68: "Пилосос 5 фільтр 1",
    KARCHER_OPERATION_COUNTER_69: "Пилосос 5 турбіна 2",
    KARCHER_OPERATION_COUNTER_70: "Пилосос 5 фільтр 2",
    KARCHER_OPERATION_COUNTER_71: "Пилосос 6 турбіна 1",
    KARCHER_OPERATION_COUNTER_72: "Пилосос 6 фільтр 1",
    KARCHER_OPERATION_COUNTER_73: "Пилосос 6 турбіна 2",
    KARCHER_OPERATION_COUNTER_74: "Пилосос 6 фільтр 2",
    KARCHER_OPERATION_COUNTER_75: "Злийте воду з конденсату компресора",
    KARCHER_OPERATION_COUNTER_76: "Перевірте систему захисту від замерзання",
    KARCHER_OPERATION_COUNTER_77: "Вентилятор пальника",
    KARCHER_OPERATION_COUNTER_78: "Підсилювальний насос для піни",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Список даних більше 10000 елементів",
    QR_CODE: "QR-код",
    ACCEPT_TERMS_AND_CONDITIONS: "Прийняти умови використання",
    CREATE_AND_PRINT_VOUCHERS: "Створити та роздрукувати купони",
    CODE_PREFIX_QUESTION: "Префікс коду не введено",
    CODE_PREFIX_QUESTION_TEXT: "Ви хочете продовжити без префікса коду?",
    ISSUED_DATE: "Дата видачі",
    VOUCHER_VALIDITY_DAYS: "Термін дії купона (дні)",
    IDENTIFICATION_CODE: "Ідентифікаційний код",
    VALIDATION_ONLY_NUMBERS: "Дозволені лише цифри",
    REPRINT_VOUCHERS: "Роздрукувати копію купонів",
    EXPIRY_DATE: "Дійсний до",
    VOUCHER_TYPE_VACUUM: "Ваучер на: Пилосос",
    VOUCHER_TYPE_JETWASH: "Ваучер на: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Ваучер на: Matt"
  });
})();
